import { render, staticRenderFns } from "./emotlist.vue?vue&type=template&id=317bc1e2&scoped=true&"
import script from "./emotlist.vue?vue&type=script&lang=js&"
export * from "./emotlist.vue?vue&type=script&lang=js&"
import style0 from "./emotlist.vue?vue&type=style&index=0&id=317bc1e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317bc1e2",
  null
  
)

export default component.exports